// extracted by mini-css-extract-plugin
export var contentBody = "_d9-9";
export var headerImage = "_d9-2";
export var imageButton = "_d9-7";
export var imageButtonIcon = "_d9-8";
export var imageHeader = "_d9-4";
export var imageHeaderText = "_d9-5";
export var imageOverlay = "_d9-3";
export var imageTitle = "_d9-6";
export var imageWrapper = "_d9-1";
export var taskList = "_d9-a";
export var widget = "_d9-0";